import { ImagePromotion } from './styles'
import { useWindowDimensions } from 'src/contexto/hooks/useWindowDimensions'

type PromotionImagesProps = {
  promotionImages: {
    desktop: string | undefined
    mobile: string | undefined
  }
}

export default function PromotionFlag({
  promotionImages,
}: PromotionImagesProps) {
  const { width } = useWindowDimensions()
  const isMobile = width! <= 768

  const image = isMobile ? promotionImages?.mobile : promotionImages?.desktop

  return promotionImages?.mobile || promotionImages?.desktop ? (
    <ImagePromotion src={image} />
  ) : null
}
